export const PLANS = [
  {
    id: "0",
    name: "2-Week Trial",
    nameBQ: "2-week",
    price: "$19.95",
    oldPrice: "$42.00",
    priceDay: "$1.42",
    oldPriceDay: "$2.97",
  },
  {
    id: "1",
    name: "4-Week Plan",
    nameBQ: "4-week",
    price: "$29.95",
    oldPrice: "$83.00",
    activeTrial: "Most Popular",
    priceDay: "$1.06",
    oldPriceDay: "$2.35",
  },
  {
    id: "2",
    name: "8-Week Plan",
    nameBQ: "8-week",
    price: "$49.95",
    oldPrice: "$167.00",
    priceDay: "$0.89",
    oldPriceDay: "$1.77",
  },
];

export const PriceFunneleData = {
  0: {
    plan_name: "2-Week Trial",
    trial_type: "paid trial",
    trial_duration_days: 14,
    // trial_price: 42.0,
    trial_price: "19.95",
    subscription_duration_days: 30,
    subscription_price: 79.95,
    product_id: "683a6e64-90f6-426f-800a-81da5f795f11",
    currency: "USD",
    original_price: 42.0,
    discount_percent: 54,
    // your_price: "42.00",
    discount_value: "22.00",
    // total: "19.95",
    // weeks: "2",
  },
  1: {
    plan_name: "4-Week Plan",
    trial_type: "paid trial",
    trial_duration_days: 28,
    // trial_price: 83.0,
    trial_price: "29.95",
    subscription_duration_days: 30,
    subscription_price: 79.95,
    product_id: "438e21f4-8c27-4820-81b6-ff2461a46e92",
    currency: "USD",
    original_price: 83.0,
    discount_percent: 64,
    // your_price: "83.00",
    discount_value: "53.00",
    // total: "29.95",
    // weeks: "4",
  },
  2: {
    plan_name: "8-Week Plan",
    trial_type: "paid trial",
    trial_duration_days: 56,
    // trial_price: 167.0,
    trial_price: "49.95",
    subscription_duration_days: 30,
    subscription_price: 79.95,
    product_id: "557bcd7c-3b0d-4c17-a20d-01bff1726516",
    currency: "USD",
    original_price: 167.0,
    discount_percent: 70,
    // your_price: "167.00",
    discount_value: "117.00",
    // total: "49.95",
    // weeks: "8",
  },
};
